// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1jOvf","label":"Category_label__3uRuV","content":"Category_content__tgKR_","header":"Category_header__37seM","location":"Category_location___yPJ9"};